import React, { Component } from 'react';
import Cons from '../../../../isomorphic/cons';
import moment from 'moment';
import propsTypes from 'prop-types';

export default class TitleBar extends Component {
    render() {
        const generateDeadlineCalculatedStatus = date => {
            const today = moment(),
                deadlineDate = moment(date, 'YYYY-MM-DD'),
                dateDiff = deadlineDate.diff(today.format('YYYY-MM-DD'), 'days');
            if (deadlineDate.isBefore(today, 'day')) {
                return `Overdue by ${dateDiff * -1} day${dateDiff !== -1 ? 's' : ''}`;
            } else if (deadlineDate.isSame(today, 'day')) {
                return 'Due Today';
            } else {
                if (dateDiff === 1) {
                    return 'Due Tomorrow';
                }
                return `Due`;
            }
        };

        const step = this.props.step,
            hasReason =
                step.state.latestTransition &&
                [Cons.transitionTypes.NotApplicable, Cons.transitionTypes.Waiting].includes(
                    step.state.latestTransition.status
                ),
            latestTransitionDate =
                step.state.latestTransition && step.state.latestTransition.status === Cons.transitionTypes.Active
                    ? step.state.latestTransition.createdOn
                    : null,
            numberOfAdditionalReasons = step.state.latestTransition
                ? step.state.latestTransition.reasons.length - 1
                : 0,            
            hideDueDate = this.ShouldThisTypesDueDateTitleBeHided(this.props.step.type || '') || false,
            dueDateText = generateDeadlineCalculatedStatus(this.props.deadlineCalculated.toString());
        const renderTitleStatusIcon = step => {
            if (step.state.isComplete) {
                return (
                    <span className="pull-right">
                        <i style={{ marginLeft: '5px' }} className="fa fa-check-circle"></i>
                    </span>
                );
            } else if (step.state.isSkipped) {
                return (
                    <span className="pull-right">
                        <i className="icon-skytc-na"></i>
                    </span>
                );
            } else if (step.state.latestTransition) {
                switch (step.state.latestTransition.status) {
                    case Cons.transitionTypes.Waiting:
                        return (
                            <span className="pull-right">
                                <i style={{ marginLeft: '5px' }} className="icon-skytc-waiting"></i>
                            </span>
                        );
                    case Cons.transitionTypes.NotApplicable:
                        return (
                            <span className="pull-right">
                                <i style={{ marginLeft: '5px' }} className="icon-skytc-na"></i>
                            </span>
                        );
                    default:
                        return null;
                }
            } else {
                return null;
            }
        };

        return (
            <a style={{ display: 'contents' }}
                data-toggle="collapse"
                data-parent={'#' + this.props.accordionId}
                href={'#' + step.stepId}
                className={'title-bar'}
            >
                <div className={'flex-parent'} style={{ width: 720 }}>
                    <span className={'flex-child long-and-truncated'}>
                        {step.title}
                        <i style={{ marginLeft: 5, marginRight: 5 }} className="fa fa-vertical-line" />
                        {hasReason && !step.state.isComplete ? `${step.state.latestTransition.reasons[0]}` : ''}
                    </span>

                    <span className={'flex-child short-and-fixed'}>
                        {numberOfAdditionalReasons > 0 && !step.state.isComplete
                            ? `, +${numberOfAdditionalReasons} Reasons`
                            : ``}
                    </span>
                    <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
                        {!step.state.isComplete && !hideDueDate ? (
                            <i style={{ marginLeft: 5, marginRight: 5 }} className="fa fa-vertical-line" />
                        ) : null}

                        {!step.state.isComplete && !hideDueDate ? (
                            <span className={'flex-child short-and-fixed due-text'}>{dueDateText}</span>
                        ) : null}

                        {!step.state.isComplete && !hideDueDate ? (
                            <span className={'flex-child short-and-fixed due-date'}>
                                {moment(this.props.deadlineCalculated).format('L')}
                            </span>
                        ) : null}

                        {/*Completed Step*/}
                        {step.state.isComplete ? (
                            <i style={{ marginLeft: 5, marginRight: 5 }} className="fa fa-vertical-line" />
                        ) : null}
                        {step.state.isComplete ? (
                            <span className={'flex-child short-and-fixed'}>
                                {step.state.isComplete
                                    ? `Completed${
                                          latestTransitionDate ? ' on ' + moment(latestTransitionDate).format('L') : ''
                                      }`
                                    : ''}
                            </span>
                        ) : null}
                        {renderTitleStatusIcon(step)}
                    </div>
                </div>
            </a>
        );
    }
    /**
     * 
     * @param { string} typeOfStep is the type of step, is a string
     * @returns true if the step due date should be hided or false if not
     */
    ShouldThisTypesDueDateTitleBeHided(typeOfStep){
        const typesThatsDueDateShouldBeHided = 
        [
            'congrats-email',
            'congrats-email-sale',
            'congrats-email-listing-gone-pending',
            'introduction-buyer-email',
            'introduction-seller-email',
            'introduction-seller',
            'introduction-co-op-agent-sale-email',
            'intro-email-escrow-title',
            'create-invoice',
            'send-invoice',
            'file-setup-email-sale',
            'confirm-read',
            'calendar',
        ];
        return typesThatsDueDateShouldBeHided.includes(typeOfStep);
    }
}
TitleBar.propsTypes = {
    step: propsTypes.object.isRequired,
    timelineEventInstance: propsTypes.object.isRequired,
    accordionId: propsTypes.string.isRequired,
    hideDueDate: propsTypes.bool,
};



// WEBPACK FOOTER //
// ./src/workflow/steps/components/title-bar.js